import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, Renderer2} from '@angular/core';
import {MediaMatcher} from '@angular/cdk/layout';
import {AuthActionTypes} from '../../../store/actions/auth.actions';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState} from '../../../store/app.states';
import {User} from '../../../model/user/User';
import {ToolbarService} from "../../../services/toolbar.service";

/** @title Responsive sidenav */
@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css'],
})
export class SidenavComponent implements OnDestroy, AfterViewInit {
  mobileQuery: MediaQueryList;
  // tslint:disable-next-line:variable-name
  private _mobileQueryListener: () => void;
  user: User | null;
  @Input() back: boolean;
  @Input() destination: string;
  @Input() notifications: number;
  // serve per indicare se sono arrivati messaggi da leggere
  messagesUnread: boolean;

  constructor(changeDetectorRef: ChangeDetectorRef,
              media: MediaMatcher,
              private router: Router,
              private store: Store<AppState>,
              private elementRef: ElementRef,
              private renderer: Renderer2,
              private toolbarService: ToolbarService) {

    const chromeAgent = navigator.userAgent.indexOf('Chrome') > -1;
    // Detect Safari
    let safariAgent = navigator.userAgent.indexOf('Safari') > -1;

    // Discard Safari since it also matches Chrome
    if ((chromeAgent) && (safariAgent)) { safariAgent = false; }

    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();

    if (safariAgent) {
      this.mobileQuery.addListener(this._mobileQueryListener);
    } else {
      this.mobileQuery.addEventListener('change', this._mobileQueryListener);
    }

    document.addEventListener('notification', () => {
      setTimeout(() => {
        this.notifications = 0;
        this.user = JSON.parse(localStorage.getItem('user'));
        this.user.notifications.forEach(n => {
          if (n.read === false) {
            ++this.notifications;
          }
        });
      }, 500);
    });

    document.addEventListener('update-notification', () => {
      setTimeout(() => {
        this.notifications = 0;
        this.user = JSON.parse(localStorage.getItem('user'));
        this.user.notifications.forEach(n => {
          if (n.read === false) {
            ++this.notifications;
          }
        });
      }, 500);
    });

    this.setup();

    setTimeout(() => {
      const user = JSON.parse(localStorage.getItem('user'));
      if (this.user !== null && this.user !== undefined) {
        if (user.notifications !== this.user.notifications) {
          this.user = user;
          this.setup();
        }
      }
    }, 1000);
    // permette di rimanere aggiornati se qualcuno legge tutti i messaggi o se ce ne sono nuovi da leggere.
    this.toolbarService.getMessageUnreadObs().subscribe(v => this.messagesUnread = v);

  }


  setup() {
    this.user = JSON.parse(localStorage.getItem('user'));
    if (this.user !== null && this.user !== undefined) {
      if (this.user.notifications !== null && this.user.notifications !== undefined) {
        this.notifications = 0;
        this.user.notifications.forEach(n => {
          if (n.read === false) {
            ++this.notifications;
          }
        });
      }
      if (this.notifications === null || this.notifications === undefined) {
        this.notifications = 0;
      }
      // controllo se ci sono messaggi da leggere.
      this.toolbarService.getNumberMessagesUnread()
        .subscribe(x => {
            if(x > 0){
              this.toolbarService.updateMessageUnreadBadge(true);
            }
          }
        );
    } else {
      this.notifications = 0;
    }
  }

  ngOnDestroy(): void {
    const chromeAgent = navigator.userAgent.indexOf('Chrome') > -1;
    // Detect Safari
    let safariAgent = navigator.userAgent.indexOf('Safari') > -1;

    // Discard Safari since it also matches Chrome
    if ((chromeAgent) && (safariAgent)) { safariAgent = false; }

    if (safariAgent) {
      this.mobileQuery.removeListener(this._mobileQueryListener);
    } else {
      this.mobileQuery.removeEventListener('change', this._mobileQueryListener);
    }
  }

  public onLogout() {
    console.log('onLogout()');
    this.store.dispatch({type: AuthActionTypes.LOGOUT});
  }

  goTo(destination) {
    this.router.navigateByUrl('/' + destination);
  }

  public ngAfterViewInit(): void {
    const listItems = this.elementRef.nativeElement.querySelectorAll('.mat-list-item-content') as HTMLElement[];
    listItems.forEach(listItem => {
      this.renderer.setStyle(listItem, 'padding', '0px');
    });
  }

  detect($event) {
    console.log($event);
    console.log('SWIPE');
  }

  onSwipe(event) {
    console.log(event);
  }

  goToSettings() {
    this.router.navigateByUrl('/settings');
  }
}
